import { render, staticRenderFns } from "./DocumentationIntro.vue?vue&type=template&id=b7a71086"
import script from "./DocumentationIntro.vue?vue&type=script&lang=js"
export * from "./DocumentationIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports